import styled from "styled-components";
import {SIZES} from "@/components/constants";
import SolutionIcon01 from "@public/assets/main/solution-icon-01.png"
import SolutionIcon02 from "@public/assets/main/solution-icon-02.png"
import SolutionIcon03 from "@public/assets/main/solution-icon-03.png"
import SolutionIcon04 from "@public/assets/main/solution-icon-04.png"


const SolutionSummerySection = ({data}) => {
    return(
        <SectionWrap>
            <div className={"container"}>
                <h2 className={"solution-title"} dangerouslySetInnerHTML={{__html: data["solution-summary"]}}/>
                <div className={"solution-box"}>
                    <div className={"info"}>
                        <div className={"box-wrap"}>
                            <img src={SolutionIcon01?.src} alt={"Packaging icon"}/>
                            <div className={"box-item"}>
                                <h3 className={"item-title"} dangerouslySetInnerHTML={{__html: data["solution1-text"]}}/>


                                <ul className={"item-text-box"}>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution1-desc1"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution1-desc2"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution1-desc3"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution1-desc4"]}}/>
                                </ul>
                            </div>
                        </div>
                        <div className={"box-wrap"}>
                        <img src={SolutionIcon02?.src} alt={"Cooling Materials icon"}/>
                            <div className={"box-item"}>
                                <h3 className={"item-title"} dangerouslySetInnerHTML={{__html: data["solution2-text"]}}/>
                                <ul className={"item-text-box"}>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution2-desc1"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution2-desc2"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution2-desc3"]}}/>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className={"middle"}></div>
                    <div className={"info"}>
                        <div className={"box-wrap"}>
                            <img src={SolutionIcon03?.src} alt={"Wearable icon"}/>
                            <div className={"box-item"}>
                                <h3 className={"item-title"} dangerouslySetInnerHTML={{__html: data["solution3-text"]}}/>
                                <ul className={"item-text-box"}>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution3-desc1"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution3-desc2"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution3-desc3"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution3-desc4"]}}/>
                                </ul>
                            </div>
                        </div>
                        <div className={"box-wrap"}>
                        <img src={SolutionIcon04?.src} alt={"Platform Service icon"}/>
                            <div className={"box-item"}>
                                <h3 className={"item-title"} dangerouslySetInnerHTML={{__html: data["solution4-text"]}}/>
                                <ul className={"item-text-box"}>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution4-desc1"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution4-desc2"]}}/>
                                    <li className={"item-inner"} dangerouslySetInnerHTML={{__html: data["solution4-desc3"]}}/>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 40px 0 60px;
    .container{
        padding: 0 24px;
        width: 100%;
        margin: 0 auto;
        gap: 64px;
        display: flex;
        flex-direction: column;
        .solution-title{
            font-size: 24px;
            line-height: 64px;
            font-weight: 700;
        }
        .solution-box{
            display: flex;
            flex-direction: column;
            .info{
                gap: 40px;
                justify-content: space-between;
                flex-direction: column;
                display: flex;
                .box-wrap{
                    gap: 40px;
                    flex-grow: 1;
                    display: flex;
                    flex-direction: column;
                    border-color: #f0f0f1;
                    img{
                        width: 144px;
                        height: 144px;
                    }
                    .box-item{
                        display: flex;
                        flex-direction: column;
                        gap: 16px;
                        .item-title{
                            font-weight: 700;
                            font-size: 24px;
                            line-height: 32px;
                            margin-bottom: 16px;
                        }
                        .item-text-box{
                            gap: 12px;
                            display: flex;
                            flex-direction: column;
                            .item-inner{
                                font-size: 16px;
                                line-height: 38px;
                            }
                        }
                    }
                }
            }
            .middle{
                width: 100%;
                height: 1px;
                background-color: #f0f0f1;
            }
        }
    }


    @media not all and (min-width: ${SIZES.MOBILE}) {
        .container{
            .solution-title{
                text-align: center;
                line-height: 38px;
            }
            .solution-box{
                .info{
                    .box-wrap{
                        text-align: center;
                        img{
                            margin: 0 auto;
                        }
                        .box-item{
                            .item-text-box{
                                .item-inner{
                                    line-height: 28px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media not all and (min-width: ${SIZES.MOBILE}) {
        .container{
            .solution-box{
                gap: 40px;
                .middle{
                    display: none;
                }
            }
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            .solution-box{
                .info{
                    .box-wrap{
                        flex-direction: row;    
                    }
                }
            }
        }
    }
    
    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            .solution-title{
                font-size: 30px;
                line-height: 36px;
            }
            .solution-box{
                .info{
                    .box-wrap{
                        img{
                            width: 160px;
                            height: 160px;
                        }
                        .box-item{
                            padding-top: 80px;
                            gap: 24px;
                            .item-title{
                                font-size: 30px;
                                line-height: 36px;
                                margin-bottom: 24px;
                            }
                            .item-text-box{
                                .item-inner{
                                    font-size: 18px;
                                    line-height: 28px;
                                }
                            }
                        }
                    }
                }
                .middle{
                    margin: 40px 0;
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET}) {
        padding: 80px 0 120px;
        .container{
            max-width: 1024px;
            padding: 0 40px;
            .solution-title{
                font-size: 40px;
            }
            .solution-box{
                .info{
                    flex-direction: row;
                    .box-wrap{
                        &:first-child{
                            padding-right: 40px;
                            border-right: 1px solid #f0f0f1;
                        }

                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.TABLET_L}) {
        .container{
            max-width: 1280px;
            .solution-box{
                .info{
         
                    .box-wrap{
                        .box-item{
                            .item-title{
                                font-size: 36px;
                                line-height: 40px;
                            }    
                            .item-text-box{
                                .item-inner{
                                    font-size: 22px;
                                }
                            }
                        }
                        img{
                            width: 220px;
                            height: 220px;
                        }
                    }
                }
            }
        }
    }
    @media (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`
export default SolutionSummerySection;